// All of these functions call immediately when application2.jsx is loaded
// Only put functions here that ARE critical to the immediate customer experience
// and do not take long to run, since it will block the main thread
const onAppLoad = () => {}

export default onAppLoad
